import loadable from '@loadable/component'

export default [
  // bd中心 index
  {
    path: '/bdCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BdCenterIndex" */ '~/pages/BdCenter/page/Index'
        )
    ),
  },
  // bd中心 邀请公会
  {
    path: '/bdCenter/inviteUnion',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-inviteUnion" */ '~/pages/BdCenter/page/inviteUnion'
        )
    ),
  },
  // bd中心 邀请支持者
  {
    path: '/bdCenter/inviteSupporter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-inviteSupporter" */ '~/pages/BdCenter/page/inviteSupporter'
        )
    ),
  },
  // bd中心 流水
  {
    path: '/bdCenter/revenue',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-revenue" */ '~/pages/BdCenter/page/revenue'
        )
    ),
  },
  // bd中心 bd邀请码(站外链接)
  {
    path: '/bdCenter/invitedCode/:mid',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-invitedCode" */ '~/pages/BdCenter/page/InvitedCode'
        )
    ),
  },
  // bd中心 bd邀请码
  {
    path: '/bdCenter/inviteNewUser',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-inviteNewUser" */ '~/pages/BdCenter/page/inviteNewUser'
        )
    ),
  },
]
